import styled from 'styled-components'
import { svgStroke } from 'utilities/styled'

export const Wrapper = styled.span`
    display: flex;
    column-gap: 8px;
    align-items: center;

    svg {
        ${svgStroke()}
    }
`